const toFiniteSeq = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  const seq = Number(value);

  if (!Number.isFinite(seq) || seq <= 0) {
    return null;
  }

  return seq;
};

export default toFiniteSeq;
